module.exports = __webpack_public_path__ + "img/jgwab.33e1774a.png";